enum BookingType
{
    GuestList = 0,
    TableBooking = 1,
    PrivateParty = 2,
    NotSet = 3,
    JoinVIPTable = 4,
}

export default BookingType;
